import { c as _c } from "react/compiler-runtime";
import type { Role } from '@svenskaspelab/nova-core/nextjs/auth';
import type { CouponIndex } from '@svenskaspelab/poolbetting/schema/coupon';
import type { DrawNumber } from '@svenskaspelab/poolbetting/schema/draw';
import type { Definition } from '@svenskaspelab/poolbetting/schema/frameworks';
import type { RetailerBalanceResult } from '@svenskaspelab/poolbetting/schema/marketplace';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@svenskaspelab/ui/react/tabs';
import type { ReactNode } from 'react';
import CouponOverviewContainer from './CouponOverviewContainer';
import CouponsOverviewTabsLabel from './CouponsOverviewTabsLabel';
type CouponsOverviewProps = {
  couponIndices: CouponIndex[];
  currentCouponIndex: CouponIndex;
  drawNumber: DrawNumber;
  product: Definition['drawProducts'][number];
  retailerData?: RetailerBalanceResult;
  role: Role;
};

/**
 * CouponsOverview component.
 *
 * @param root0 - The props object.
 * @param root0.couponIndices - An array of coupon indices to display in the tabs.
 * @param root0.drawNumber - The current draw number.
 * @param root0.product - The product type.
 * @param root0.retailerData - Retailer balance data.
 * @param root0.currentCouponIndex - The coupon index to display when only one coupon is available.
 * @param root0.role - Role of the user (e.g., 'Retailer', 'Player').
 * @returns The tabs menu and coupon overview container component.
 */
export default function CouponsOverview(t0) {
  const $ = _c(25);
  const {
    couponIndices,
    currentCouponIndex,
    drawNumber,
    product,
    retailerData,
    role
  } = t0;
  if (couponIndices.length > 1) {
    const t1 = `coupon-${couponIndices[0]}`;
    let t2;
    if ($[0] !== couponIndices) {
      t2 = couponIndices.map(_temp);
      $[0] = couponIndices;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2) {
      t3 = <TabsList alignment="left">{t2}</TabsList>;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== couponIndices || $[5] !== drawNumber || $[6] !== product || $[7] !== retailerData || $[8] !== role) {
      let t5;
      if ($[10] !== drawNumber || $[11] !== product || $[12] !== retailerData || $[13] !== role) {
        t5 = couponIndex_0 => <TabsContent key={`content-${couponIndex_0}`} value={`coupon-${couponIndex_0}`}><CouponOverviewContainer couponIndex={couponIndex_0} drawNumber={drawNumber} product={product} retailerData={retailerData} role={role} hasMultipleCoupons={true} /></TabsContent>;
        $[10] = drawNumber;
        $[11] = product;
        $[12] = retailerData;
        $[13] = role;
        $[14] = t5;
      } else {
        t5 = $[14];
      }
      t4 = couponIndices.map(t5);
      $[4] = couponIndices;
      $[5] = drawNumber;
      $[6] = product;
      $[7] = retailerData;
      $[8] = role;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[15] !== t1 || $[16] !== t3 || $[17] !== t4) {
      t5 = <Tabs className="mt-2 lg:mr-6 lg:ml-6" defaultValue={t1}>{t3}{t4}</Tabs>;
      $[15] = t1;
      $[16] = t3;
      $[17] = t4;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    return t5;
  }
  let t1;
  if ($[19] !== currentCouponIndex || $[20] !== drawNumber || $[21] !== product || $[22] !== retailerData || $[23] !== role) {
    t1 = <CouponOverviewContainer couponIndex={currentCouponIndex} drawNumber={drawNumber} product={product} retailerData={retailerData} role={role} />;
    $[19] = currentCouponIndex;
    $[20] = drawNumber;
    $[21] = product;
    $[22] = retailerData;
    $[23] = role;
    $[24] = t1;
  } else {
    t1 = $[24];
  }
  return t1;
}
function _temp(couponIndex) {
  return <TabsTrigger key={`tabs-${couponIndex}`} value={`coupon-${couponIndex}`}><CouponsOverviewTabsLabel couponIndex={couponIndex} /></TabsTrigger>;
}